import showErrors from "../errors/showErrors.js";

export default async function () {
    try {
        this.disableInputs();
        this.loading = true;
        let form_data = new FormData;
        form_data.append('action', ajax_var.action_check_email);
        form_data.append('email', this.dataInput.value);
        form_data.append('nonce', ajax_var.nonce);

        const response = await axios.post(ajax_var.url, form_data);
        this.enableInputs();

        if (response.status != 200) {
            throw new Error(response);
        }

        this.loading = false;

        if (response.data != false) {
            this.$router.push('/signin/');
        } else {
            this.$router.push('/fullName/');
        }
    } catch (error) {
        showErrors.bind(this)('checkEmailLegacy', error);
        this.loading = false;
        this.enableInputs();
    }
};
